import type { FC, ReactNode } from 'react'

import Image from 'next/image'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { BookingForm } from '@/components/contact/booking-form'
import { Faq } from '@/components/contact/faq'
import { Choose } from '@/components/home/choose'
import { bookingHero, bookingHeroAlt, bookingIntro } from '@/constants/contact'

const Contact: FC = (): ReactNode => {
    return (
        <Layout transparentHeader>
            <Seo
                title="Book a room in Killington, VT"
                description="Send your dates to the Greenbrier Inn in Killington, Vermont, or call the hotel at 802-775-1608 to book a room and add discounted lift tickets."
            />

            <section className='relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden bg-ink px-4 py-[110px] md:px-8 md:py-[130px]'>
                <div className='absolute inset-0'>
                    <Image
                        src={bookingHero}
                        alt={bookingHeroAlt}
                        fill
                        priority
                        sizes='100vw'
                        className='object-cover'
                    />
                </div>

                <div
                    className='relative w-full max-w-[538px] rounded-[20px] bg-cream p-6 md:p-[38px]'
                    data-reveal='up'
                    data-reveal-load
                    data-reveal-delay='0.4'
                >
                    <h1 className='text-center font-heading text-[36px] font-medium leading-[1.05] tracking-[-0.03em] text-brand md:text-[46px]'>
                        Book your{' '}

                        <em>
                            Vacation
                        </em>
                    </h1>

                    <p className='mx-auto mt-3 max-w-[380px] text-center text-[15px] leading-[1.5] text-ink-soft'>
                        {bookingIntro}
                    </p>

                    <div className='mt-8'>
                        <BookingForm />
                    </div>
                </div>
            </section>

            <Faq />

            <Choose />
        </Layout>
    )
}

export default Contact
